/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ConfirmTransferDialog.vue?vue&type=template&id=0a41efc8"
import script from "./ConfirmTransferDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmTransferDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a41efc8')) {
      api.createRecord('0a41efc8', component.options)
    } else {
      api.reload('0a41efc8', component.options)
    }
    module.hot.accept("./ConfirmTransferDialog.vue?vue&type=template&id=0a41efc8", function () {
      api.rerender('0a41efc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/ConfirmTransferDialog.vue"
export default component.exports